import digiDesign from "../assets/images/digiplus.png";
import ficasDesign from "../assets/images/ficas.png";
import parsDesign from "../assets/images/parsshir.png";

import BigData from "../assets/images/BigData.jpeg";
import ObjectDetection from "../assets/images/ObjectDetection.webp";
import ImageCaptioning from "../assets/images/captiongenerator.gif";
import ElectricityConsumptionForecast from "../assets/images/ElectricityConsumptionForecast.jpg";

import blogImage2 from "../assets/images/blog-image-2.jpg";
import blogImage6 from "../assets/images/blog-image-6.jpg";
import blogImage7 from "../assets/images/AboutImg.jpg";

const fa = {
  locale: "fa",

  name: "مهدی طالبی",
  navRole: "مهندس هوش مصنوعی",
  openNavigation: "باز کردن منو",

  home: "صفحه اصلی",
  about: "درباره من",
  resume: "رزومه",
  portfolio: "پروژه‌ها",
  blog: "نوشته‌ها",
  contact: "ارتباط با من",

  hi: "سلام، من ",
  hi2: " هستم",

  homeKicker: "هوش مصنوعی کاربردی · یادگیری ماشین · مهندسی نرم‌افزار",
  homeHeadline: "سیستم‌های هوشمندی می‌سازم که پژوهش را به محصول واقعی وصل می‌کنند.",
  desc:
    "در حوزه هوش مصنوعی کاربردی، یادگیری ماشین، بینایی کامپیوتر و مهندسی نرم‌افزار فعالیت می‌کنم. تجربه من از پژوهش در ردیابی چند شی و ادراک خودروهای خودران تا ساخت سیستم‌های پیشنهاد محصول، رتبه‌بندی، جست‌وجوی شباهت تصویری، کشف هوشمند محصول و ابزارهای مبتنی بر AI برای کسب‌وکار را شامل می‌شود.",

  homeProofTitle: "حوزه‌های اصلی کار من",
  homeProofLead: "سه محور اصلی که پژوهش و تجربه حرفه‌ای فعلی من را بهتر از بقیه توضیح می‌دهند.",

  homeSignals: [
    "پژوهش — SNN + BLS، ردیابی چند شی، ادراک خودروهای خودران و دیتاست KITTI.",
    "هوش مصنوعی کاربردی — پیشنهاددهی، رتبه‌بندی، شخصی‌سازی، جست‌وجوی تصویری و کشف هوشمند محصول.",
    "مهندسی — Python، React، API، جریان‌های داده، سیستم‌های تجارت الکترونیک و نرم‌افزارهای عملیاتی وب.",
  ],

  viewProjects: "مشاهده پروژه‌ها",
  downloadcv: "دانلود رزومه",

  aboutme: "درباره من",
  aboutEyebrow: "معرفی",
  aboutDescription:
    "در مرز میان هوش مصنوعی کاربردی، بینایی کامپیوتر، یادگیری ماشین و مهندسی نرم‌افزار کار می‌کنم. مسیر حرفه‌ای من ترکیبی از پژوهش و ساخت محصول است؛ از ردیابی چند شی و ادراک خودروهای خودران گرفته تا سیستم‌های پیشنهاددهنده، جست‌وجوی شباهت بصری، کشف هوشمند محصول، دستیارهای هوشمند و نرم‌افزارهایی که در فرایندهای واقعی کسب‌وکار استفاده می‌شوند. برای من کیفیت مهندسی، قابلیت نگهداری و کاربرد واقعی یک سیستم به اندازه خود مدل اهمیت دارد.",
  aboutJourney:
    "مسیر دانشگاهی من با کارشناسی مهندسی نساجی در دانشگاه صنعتی امیرکبیر شروع شد. بعد از آن با شرکت در مسیر ورود مهندسی کامپیوتر، رشته خود را تغییر دادم و کارشناسی ارشد علم داده را در دانشگاه شهید بهشتی با تمرکز پژوهشی روی هوش مصنوعی و بینایی کامپیوتر به پایان رساندم.",
  aboutImageAlt: "محیط کاری مرتبط با هوش مصنوعی و مهندسی نرم‌افزار",
  aboutFocusTags: [
    "هوش مصنوعی کاربردی",
    "یادگیری ماشین",
    "بینایی کامپیوتر",
    "سیستم‌های پیشنهاددهنده",
    "جست‌وجوی هوشمند",
    "مهندسی نرم‌افزار",
  ],

  coreAreasTitle: "حوزه‌های اصلی فعالیت",
  coreAreasEyebrow: "تمرکز حرفه‌ای",
  coreAreas: [
    {
      id: "ai",
      icon: "ai",
      title: "هوش مصنوعی کاربردی و یادگیری ماشین",
      desc:
        "طراحی قابلیت‌های هوشمند برای مسائل واقعی محصول و کسب‌وکار؛ شامل پیشنهاددهی، رتبه‌بندی، شخصی‌سازی، جست‌وجوی هوشمند و تصمیم‌گیری مبتنی بر داده.",
    },
    {
      id: "cv",
      icon: "cv",
      title: "بینایی کامپیوتر و ادراک هوشمند",
      desc:
        "پژوهش و توسعه در تشخیص اشیا، ردیابی چند شی، جست‌وجوی شباهت بصری، مدل‌سازی زمانی و ادراک در سیستم‌های خودران.",
    },
    {
      id: "software",
      icon: "software",
      title: "مهندسی نرم‌افزار و محصول",
      desc:
        "ساخت نرم‌افزارهای کاربردی پیرامون سیستم‌های هوش مصنوعی با Python، JavaScript، React، API، پایگاه داده و جریان‌های عملیاتی وب و تجارت الکترونیک.",
    },
  ],

  fullname: "نام و نام خانوادگی",
  age: "سن",
  languages: "زبان‌ها",
  address: "موقعیت",
  phone: "شماره تماس",
  availabilityLabel: "وضعیت همکاری",
  persian: "فارسی",
  english: "انگلیسی",
  street: "تهران، ایران",
  available: "آماده بررسی فرصت‌های مرتبط با هوش مصنوعی و مهندسی",
  tel: "۰۹۳۵۹۷۳۲۲۶۴",

  resumePageTitle: "رزومه",
  resumeEyebrow: "تجربه و تحصیلات",
  workingexperience: "سوابق حرفه‌ای",

  workingSteps: [
    {
      id: 1,
      date: "آذر ۱۴۰۲ - اکنون",
      title: "مدیر فناوری هوش مصنوعی و وب",
      subtitle: "شرکت بین‌المللی پترو نور مهر",
      content:
        "طراحی و توسعه سیستم‌های مبتنی بر هوش مصنوعی برای محصولات و فرایندهای کسب‌وکار، از جمله دستیار هوشمند مبتنی بر پایگاه دانش و جست‌وجوی هوشمند محصولات؛ با تمرکز بر اتصال هوش مصنوعی کاربردی، داده، مهندسی وب و نیازهای واقعی تجاری.",
    },
    {
      id: 2,
      date: "آبان ۱۴۰۱ - آبان ۱۴۰۴",
      title: "دستیار پژوهشی — بینایی کامپیوتر و سیستم‌های خودران",
      subtitle: "دانشگاه شهید بهشتی",
      content:
        "پژوهش در حوزه بینایی کامپیوتر، یادگیری عمیق، خودروهای خودران و ردیابی چند شی. پژوهش کارشناسی ارشد من شامل طراحی و ارزیابی یک معماری ترکیبی از شبکه‌های عصبی ضربه‌ای و سیستم یادگیری گسترده روی دیتاست KITTI بود.",
    },
    {
      id: 3,
      date: "اسفند ۱۳۹۹ - دی ۱۴۰۰",
      title: "توسعه‌دهنده فرانت‌اند",
      subtitle: "دیجی‌کالا",
      content:
        "مشارکت در توسعه فرانت‌اند یک پلتفرم بزرگ تجارت الکترونیک و کار روی رابط‌های کاربری مبتنی بر React در محیط عملیاتی.",
    },
  ],

  educationalqualifications: "تحصیلات",
  educationalSteps: [
    {
      id: 1,
      date: "مهر ۱۴۰۱ - مهر ۱۴۰۴",
      title: "کارشناسی ارشد علم داده — مهندسی کامپیوتر",
      subtitle: "دانشگاه شهید بهشتی — دانشکده مهندسی و علوم کامپیوتر",
      content:
        "تمرکز تحصیلی و پژوهشی بر یادگیری ماشین، بینایی کامپیوتر، سیستم‌های هوشمند و ادراک خودروهای خودران. پایان‌نامه در مهر ۱۴۰۴ دفاع شد.",
    },
    {
      id: 2,
      date: "مهر ۱۳۹۴ - بهمن ۱۳۹۹",
      title: "کارشناسی مهندسی نساجی",
      subtitle: "دانشگاه صنعتی امیرکبیر — پلی‌تکنیک تهران",
      content:
        "پس از پایان دوره کارشناسی مهندسی، مسیر تحصیلی و حرفه‌ای خود را به سمت مهندسی کامپیوتر، علم داده و هوش مصنوعی تغییر دادم.",
    },
  ],

  researchSpotlight: "پژوهش شاخص",
  researchTitle: "ادغام شبکه عصبی ضربه‌ای و سیستم یادگیری گسترده برای ردیابی چند شی",
  researchDescription:
    "در پایان‌نامه کارشناسی ارشد، یک معماری ترکیبی SNN–BLS برای ردیابی چند شی در سناریوهای خودروهای خودران بررسی و پیاده‌سازی شد. این سیستم از استخراج ویژگی مبتنی بر MobileNetV3/FPN، توسعه ویژگی با Broad Learning System، لایه‌های اسپایکی مبتنی بر نورون‌های LIF و اتصال Trackها با Kalman Filter و Hungarian Algorithm استفاده می‌کند و روی KITTI ارزیابی شده است.",
  researchTags: [
    "Spiking Neural Networks",
    "Broad Learning System",
    "Multi-Object Tracking",
    "KITTI",
    "Autonomous Driving",
    "Computer Vision",
  ],
  researchStats: [
    { value: "۷۷٫۹۳", label: "HOTA روی بخش ارزیابی داخلی KITTI" },
    { value: "کمتر از ۲۷ ms", label: "زمان پردازش انتها به انتهای هر فریم روی NVIDIA A100" },
    { value: "حدود ۹٫۲٪", label: "میزان فعالیت اسپایک گزارش‌شده در معماری پیشنهادی" },
    { value: "KITTI", label: "دیتاست مورد استفاده برای ارزیابی خودروهای خودران" },
  ],

  myskills: "توانمندی‌های فنی",
  skillGroups: [
    {
      title: "هوش مصنوعی کاربردی و یادگیری ماشین",
      items: [
        "یادگیری ماشین",
        "یادگیری عمیق",
        "سیستم‌های پیشنهاددهنده",
        "سیستم‌های رتبه‌بندی",
        "شخصی‌سازی",
        "جست‌وجوی هوشمند",
        "جست‌وجوی شباهت بصری",
        "تحلیل داده",
      ],
    },
    {
      title: "بینایی کامپیوتر و پژوهش",
      items: [
        "Computer Vision",
        "Multi-Object Tracking",
        "Object Detection",
        "Re-Identification",
        "Spiking Neural Networks",
        "Broad Learning Systems",
        "Temporal Modeling",
        "OpenCV",
      ],
    },
    {
      title: "مهندسی هوش مصنوعی و داده",
      items: [
        "Python",
        "PyTorch",
        "TensorFlow",
        "Keras",
        "Scikit-learn",
        "NumPy",
        "pandas",
        "SQL",
      ],
    },
    {
      title: "مهندسی نرم‌افزار و محصول",
      items: [
        "JavaScript",
        "React",
        "Node.js",
        "REST APIs",
        "WordPress",
        "WooCommerce",
        "PHP",
        "MySQL",
      ],
    },
  ],

  portfolioEyebrow: "نمونه کار منتخب",
  portfolioLead:
    "منتخبی از پژوهش‌ها، سیستم‌های هوش مصنوعی کاربردی و پروژه‌های نرم‌افزاری من؛ با تمرکز بر مسئله فنی، آنچه پیاده‌سازی شده و ارتباط آن با یک کاربرد واقعی.",
  featuredWork: "پروژه‌های شاخص",
  selectedAIProjects: "پروژه‌های منتخب هوش مصنوعی و یادگیری ماشین",
  frontend: "سوابق و پروژه‌های پیشین مهندسی وب",
  visitProject: "مشاهده پروژه",

  featuredProjects: [
    {
      id: "javert",
      type: "هوش مصنوعی کاربردی · تجارت الکترونیک",
      title: "ژاور — سیستم‌های هوشمند تجارت و عملیات فروشگاه",
      desc:
        "طراحی و توسعه مجموعه‌ای از قابلیت‌های هوشمند برای یک کسب‌وکار واقعی پوشاک مردانه؛ شامل رتبه‌بندی چندمعیاره محصول، پیشنهاد ست هوشمند، راهنمای شخصی‌سازی‌شده سایز، جست‌وجوی شباهت بصری، مدیریت ست‌ها و ابزارهای عملیاتی مدیریت موجودی و قیمت همراه با اعلان‌های تلگرامی سفارش و موجودی.",
      tags: ["Recommendation", "Ranking", "Visual Search", "Personalization", "WooCommerce"],
      metrics: [
        "امتیازدهی براساس فروش، محبوبیت، موجودی و سایزبندی",
        "تطبیق رنگ، فصل، قواره و سازگاری ست",
        "اتوماسیون موجودی و سفارش در تلگرام",
      ],
      href: "https://javert.store",
      domain: "javert.store",
      image: "/project-shots/javert.webp",
      imageAlt: "صفحه اصلی فروشگاه ژاور",
      visualLabel: "JAVERT",
    },
    {
      id: "petro",
      type: "هوش مصنوعی کاربردی · B2B",
      title: "پترو نور مهر — دستیار هوشمند و جست‌وجوی محصول",
      desc:
        "توسعه قابلیت‌های مبتنی بر هوش مصنوعی برای کشف محصول در یک کسب‌وکار B2B پتروشیمی؛ شامل دستیار دانش‌محور مشتری و جست‌وجوی هوشمند در اطلاعات فنی محصولات و محتوای تجاری وب‌سایت.",
      tags: ["AI Assistant", "Knowledge Base", "Product Search", "B2B", "Web Engineering"],
      metrics: ["پاسخ‌گویی مبتنی بر دانش محصول", "کشف هوشمند محصولات"],
      href: "https://petronourmehr.com",
      domain: "petronourmehr.com",
      image: "/project-shots/petro.webp",
      imageAlt: "صفحه اصلی پترو نور مهر",
      visualLabel: "PNM · AI",
    },
    {
      id: "research",
      type: "پژوهش · بینایی کامپیوتر",
      title: "SNN + BLS برای ردیابی چند شی در خودروهای خودران",
      desc:
        "پژوهش کارشناسی ارشد درباره ترکیب شبکه‌های عصبی ضربه‌ای با سیستم‌های یادگیری گسترده برای ردیابی چند شی روی KITTI و ترکیب استخراج ویژگی زمانی-مکانی، توسعه ویژگی عصبی و Track Association کلاسیک.",
      tags: ["SNN", "BLS", "KITTI", "Multi-Object Tracking", "Autonomous Driving"],
      metrics: ["HOTA = ۷۷٫۹۳", "کمتر از ۲۷ ms/frame", "حدود ۹٫۲٪ فعالیت اسپایک"],
      href: "",
      domain: "پژوهش کارشناسی ارشد · KITTI",
      image: "/project-shots/thesis.webp",
      imageAlt: "نمایی از پژوهش ردیابی چند شی",
      visualLabel: "SNN × BLS",
    },
  ],

  portfoliosmlList: [
    {
      id: "intrusion",
      href: "",
      title: "تشخیص نفوذ در شبکه",
      desc: "تحلیل و پیاده‌سازی روش‌های یادگیری ماشین برای تشخیص حملات نفوذ در داده‌های شبکه.",
      image: BigData,
    },
    {
      id: "yolov8",
      href: "",
      title: "تشخیص اشیا با YOLOv8",
      desc: "پیاده‌سازی سیستم تشخیص اشیا با YOLOv8 و ارائه آن در قالب یک وب‌اپلیکیشن تعاملی مبتنی بر Streamlit.",
      image: ObjectDetection,
    },
    {
      id: "captioning",
      href: "",
      title: "تولید خودکار شرح تصویر",
      desc: "تولید و ارزیابی شرح تصویر با استفاده از CNN و LSTM روی دیتاست Flickr8k.",
      image: ImageCaptioning,
    },
    {
      id: "forecasting",
      href: "",
      title: "پیش‌بینی مصرف برق",
      desc: "پیش‌بینی سری زمانی مصرف برق با استفاده از شبکه‌های عصبی بازگشتی و LSTM.",
      image: ElectricityConsumptionForecast,
    },
  ],

  portfoliosList: [
    {
      id: "digikala",
      href: "https://digikala.com",
      title: "دیجی‌کالا",
      desc: "تجربه توسعه فرانت‌اند در یک پلتفرم بزرگ تجارت الکترونیک و رابط‌های کاربری عملیاتی مبتنی بر React.",
      image: digiDesign,
    },
    {
      id: "ficas",
      href: "https://ficas.com",
      title: "Ficas",
      desc: "تجربه توسعه فرانت‌اند و مدیریت وب‌سایت برای یک مجموعه سرمایه‌گذاری و دارایی دیجیتال در سوئیس.",
      image: ficasDesign,
    },
    {
      id: "parsshir",
      href: "https://www.pars-shir.com/",
      title: "پارس شیر",
      desc: "تجربه توسعه فرانت‌اند و بک‌اند وب‌سایت یک مجموعه صنعتی.",
      image: parsDesign,
    },
  ],

  writingPageTitle: "نوشته‌ها و مطالعه",
  writingEyebrow: "علایق فنی",
  writingIntroTitle: "مطالعه‌های منتخب فنی",
  writingLead:
    "در این صفحه منابعی را نگه می‌دارم که به حوزه‌های پژوهشی و مهندسی مورد علاقه من نزدیک‌اند؛ به‌ویژه رایانش نورومورفیک، شبکه‌های عصبی ضربه‌ای، ادراک هوشمند و سیستم‌های هوش مصنوعی کاربردی.",
  writingDisclosure: "مقاله‌های زیر منابع خارجی هستند و به‌عنوان مقاله تألیفی من معرفی نمی‌شوند.",
  writingTopics: ["Spiking Neural Networks", "Neuromorphic Computing", "Computer Vision", "Applied AI"],
  readArticle: "مطالعه در منبع اصلی",

  blogsList: [
    {
      id: "ieee-neuromorphic-big-time",
      href: "https://spectrum.ieee.org/neuromorphic-computing-2671121824",
      title: "رایانش الهام‌گرفته از مغز در آستانه کاربردهای بزرگ‌تر",
      desc:
        "IEEE Spectrum درباره حرکت رایانش نورومورفیک از نمونه‌های پژوهشی به سمت سیستم‌های بزرگ‌تر و نقش شبکه‌های عصبی ضربه‌ای در این مسیر صحبت می‌کند.",
      source: "IEEE Spectrum",
      readTime: "۶ دقیقه",
      tags: ["Neuromorphic Computing", "SNN", "AI Hardware"],
      image: blogImage6,
    },
    {
      id: "ieee-spinnaker2",
      href: "https://spectrum.ieee.org/neuromorphic-computing-spinnaker2",
      title: "SpiNNaker2 و مقیاس‌پذیری رایانش نورومورفیک",
      desc:
        "مروری کوتاه بر SpiNNaker2، پردازش رویدادمحور، مقیاس بزرگ سیستم‌های نورومورفیک و مصالحه‌های مهندسی در طراحی سامانه‌های الهام‌گرفته از مغز.",
      source: "IEEE Spectrum",
      readTime: "۳ دقیقه",
      tags: ["SpiNNaker2", "Neuromorphic Systems", "Parallel Computing"],
      image: blogImage2,
    },
    {
      id: "ieee-ai-hardware",
      href: "https://spectrum.ieee.org/ai-hardware",
      title: "سخت‌افزارهای الهام‌گرفته از مغز و شبکه‌های عصبی ضربه‌ای",
      desc:
        "گفت‌وگویی درباره شبکه‌های نورومورفیک ضربه‌ای، سخت‌افزار کم‌مصرف هوش مصنوعی و این پرسش که این معماری‌ها در چه مسائلی می‌توانند از روش‌های متعارف بهتر عمل کنند.",
      source: "IEEE Spectrum",
      readTime: "۵ دقیقه",
      tags: ["Spiking Networks", "AI Hardware", "Efficiency"],
      image: blogImage7,
    },
  ],

  contactme: "ارتباط با من",
  contactEyebrow: "تماس",
  getintouch: "در تماس باشیم",
  contactLead:
    "اگر برای یک پروژه هوش مصنوعی، فرصت مهندسی، همکاری پژوهشی یا توسعه محصول قصد ارتباط دارید، پیام خود را ارسال کنید تا در اولین فرصت پاسخ بدهم.",
  contactInfoTitle: "اطلاعات تماس",
  contactInfoLead: "از طریق اطلاعات زیر نیز می‌توانید مستقیماً با من در ارتباط باشید.",
  entername: "نام شما",
  enteremail: "ایمیل شما",
  entersubject: "موضوع",
  entermessage: "کمی درباره موضوع یا پروژه‌ای که در ذهن دارید بنویسید",
  sendmessage: "ارسال پیام",
  sending: "در حال ارسال...",
  messageSent: "پیام شما با موفقیت ارسال شد.",
  messageError: "ارسال پیام انجام نشد. دوباره تلاش کنید یا مستقیماً ایمیل بزنید.",
  email: "ایمیل",
};

export default fa;
